import { createAction } from '@lingoda/core';
import type { SectionName } from '@lingoda/sections';
import type { CurrentRoute } from './models';

export const setCurrentRoute = createAction<CurrentRoute>('route/SET_CURRENT_ROUTE');
export const setCurrentSection = createAction<SectionName>('route/SET_CURRENT_SECTION');
